export const COLORS = {
  aquaBlue: "#11a8a4",
  grassGreen: "#7ed957",
  vividPurple: "#9440dd",
  lightGrey: "#f3f4f6",
  mediumGrey: "#e5e7eb",
  darkText: "#1f2937",
  mediumText: "#6b7280",
  white: "#ffffff",
  errorBg: "#fef2f2",
  errorBorder: "#fecaca",
  errorText: "#dc2626",
};

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const STATUS_STYLES = {
  INACTIVE: { bg: "#f3f4f6", text: "#6b7280", border: "#e5e7eb" },
  ACTIVE: { bg: "#ecfdf5", text: "#047857", border: "#a7f3d0" },
  EXPIRED: { bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" },
  EXHAUSTED: { bg: "#fffbeb", text: "#b45309", border: "#fde68a" },
  CANCELLED: { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
};

const UNKNOWN_STATUS_STYLE = { bg: "#f3f4f6", text: "#374151", border: "#e5e7eb" };

export function getStatusStyle(status) {
  if (!status) return UNKNOWN_STATUS_STYLE;
  return STATUS_STYLES[status] || UNKNOWN_STATUS_STYLE;
}

export function percent(used, total) {
  const u = Number(used);
  const t = Number(total);
  if (!t) return 0;
  const p = Math.round((u / t) * 100);
  if (Number.isNaN(p)) return 0;
  return Math.min(100, Math.max(0, p));
}

export function safeNumber(value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";
  return value;
}

export function formatReference(ref) {
  if (!ref || typeof ref !== "object") return "—";
  const type = ref.type != null && ref.type !== "" ? String(ref.type) : "";
  const id = ref.id != null && ref.id !== "" ? String(ref.id) : "";
  if (!type && !id) return "—";
  return [type, id].filter(Boolean).join(" #");
}
